import React, { useEffect, useState } from "react";
import { db, storage } from "../../../config/firebase";
import { getDownloadURL, ref } from "firebase/storage";
import { COLLECTION, SESSION } from "../../../data/constant";
import { doc, getDoc,getDocs,where,query ,collection} from "firebase/firestore";

import Layout from "./Layout";

const Streaming = () => {
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false); // Modal visibility
  const [machineId, setMachineId] = useState(null);
  const [userId, setUserId] = useState(null);


  useEffect(() => {
    const fetchDocuments = async () =>    {
      try {
        // Retrieve session ID from local storage
        const sessionId = localStorage.getItem(SESSION.PUSER_SESSION_ID);
        if (!sessionId) {
          throw new Error("Session ID not found");
        }
  
        // Get user information based on session
        const sessionRef = doc(db, COLLECTION.PUSER_SESSION, sessionId);
        const sessionSnap = await getDoc(sessionRef);
  
        if (!sessionSnap.exists()) {
          throw new Error("Session data not found");
        }
  
        const { userId } = sessionSnap.data();
        setUserId(userId)

        // Query Ppods collection to find the document with matching userId
        const ppodsCollectionRef = collection(db, "Ppods");
        const ppodQuery = query(ppodsCollectionRef, where("userId", "==", userId));
        const ppodSnapshot = await getDocs(ppodQuery);
  
        if (ppodSnapshot.empty) {
          throw new Error("No matching Ppod found for the user");
        }
  
        // Assume we use the first matching Ppod document
        const ppodData = ppodSnapshot.docs[0].data();
        const { ppodNumber } = ppodData;
        setMachineId(ppodNumber)
  
    
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchDocuments();
  }, []);
  
  return (
    <Layout
      loading={loading}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      machineId={machineId}
      userId={userId}
    />
  );
};

export default Streaming;
